import { createContext, useContext, useEffect, useRef, useState } from "react"

import { LogsInitContext } from "../LogsInitComponentesContext/LogsInitComponentesContext"
import { WebSocketContext } from "../WebSocket/WebSocketContext"
import { UserContext } from "../UserContext/UserContex"
import { LogadoContext } from "../LogadoContext/LogadoContext"
import { ChangeComponentContext } from "../ChangeComponentContext/ChangeComponentContext"
import { toast } from "react-toastify"

export const CondominiosContext = createContext()

const modeloActiveCond = {
    id_central: '',
    link: '',
    apelido: '',
    nome: '',
    vms: { ip: '', porta: '', user: '', pass: '' },
    obs_liberacao_temporaria: false,
    liberacao_padrao_visitante: 0,
    notifica_morador_visitante: false,
    gerar_logs_aut_obs: true
}

export const CondominiosProvider = ({ children }) => {
    let selecionado_p_menu_lateral = useRef(false)
    const { LogInit } = useContext(LogsInitContext)
    LogInit('CondominiosContext', 'contexto')

    const [condominios, setCondominios] = useState([])
    const [activeCond, setActiveCond] = useState(modeloActiveCond)

    const { addRoute, sendWs, wsConectado } = useContext(WebSocketContext)
    const { user } = useContext(UserContext)
    const { logado } = useContext(LogadoContext)
    const { changeShowComponent } = useContext(ChangeComponentContext)

    useEffect(() => {
        if (condominios.length === 0 && logado && user.id) {
            getCondominios()
        }
    }, [condominios, user, logado])

    /**
     * Envia ao Qrtoken qual é o condominio que está selecionado para esse frontend.
     */
    if (wsConectado && activeCond && activeCond.id_central) {
        setTimeout(() => {
            sendWs('setActiveCondWebsocket', { id_central: activeCond.id_central })
        }, 700)
    }

    const getCondominios = () => {
        addRoute('getCondominios', handleGetCondominios)
        sendWs('getCondominios', { userId: user.id })
    }

    const handleGetCondominios = (msg) => {
        if (msg.data && msg.data.status && msg.data.status != 'error' && msg.data.status != 'erro') {
            setCondominios(msg.data.condominios)
            let ult_cond_escolhido = '' // buscar do banco
            let cond = msg.data.condominios.find(el => el.id_central === ult_cond_escolhido)
            let cameras_benuvem = cond?.cameras_benuvem?.length > 0 ? cond.cameras_benuvem : []
            if (cond) {
                let origin = window.location.hostname
                let link = `http://${origin}/wsonePortaria/web/?chave=${cond.chave}&usuario=${user.id}&nome=${user.nome}&zoom=80&oneversao=1`
                // link = `http://localhost/wsOnePortaria/web/?chave=${cond.chave}&usuario=${user.id}&nome=${user.nome}&zoom=80&oneversao=1`
                setActiveCond({
                    id_central: cond.id_central,
                    id: cond.id,
                    link,
                    apelido: cond.apelido,
                    nome: cond.nome,
                    cameras: cond.cameras_benuvem && cond.cameras_benuvem.length > 0 ? cond.cameras_benuvem : cond.cameras,
                    obs_liberacao_temporaria: cond.edit_obs_liberacao_temporaria,
                    tipo_imovel: cond.tipo_imovel,
                    desc_tipo_imovel: cond.desc_tipo_imovel,
                    grupos_acesso: cond.grupos_acesso,
                    cameras_benuvem,
                    chave: cond.chave,
                    fecha_evento_visitante_automatico: cond.fecha_evento_visitante_automatico,
                    liberacao_padrao_visitante: cond.liberacao_padrao_visitante,
                    notifica_morador_visitante: cond.notifica_morador_visitante,
                    nome_doc1: cond.nome_doc1,
                    nome_doc2: cond.nome_doc2,
                    nome_doc3: cond.nome_doc3,
                    doc1_obrigatorio: cond.doc1_obrigatorio,
                    doc2_obrigatorio: cond.doc2_obrigatorio,
                    doc3_obrigatorio: cond.doc3_obrigatorio,
                    pais: cond.pais,
                    gerar_logs_aut_obs: cond.gerar_logs_aut_obs,
                    cpf_obrigatorio: cond.cpf_obrigatorio
                })
            }
        }
    }

    const addActiveCond = (id_central, selecionado_p_menu_lateral_ = false, id_one_log = false) => {
        selecionado_p_menu_lateral.current = selecionado_p_menu_lateral_

        if (activeCond.id_central == id_central) {
            if (id_one_log && global.Enviar_Mensagem_AbaWeb && typeof global.Enviar_Mensagem_AbaWeb == 'function') {
                global.Enviar_Mensagem_AbaWeb({ cmd: 'id_one_log', id_one_log }) // Envia o id_one_log do evento selecionado para aba web
            }

            return true
        }

        let cond = condominios.find(cond => cond.id_central === id_central)
        if (!cond) {
            return false
        }
        let origin = window.location.hostname
        let cameras_benuvem = cond.cameras_benuvem?.length > 0 ? cond.cameras_benuvem : []
        let link = `http://${origin}/wsonePortaria/web/?chave=${cond.chave}&usuario=${user.id}&nome=${user.nome}&zoom=80&oneversao=1`
        // link = `http://localhost/wsOnePortaria/web/?chave=${cond.chave}&usuario=${user.id}&nome=${user.nome}&zoom=80&oneversao=1`
        link += (id_one_log && id_one_log != "" ? `&id_one_log=${id_one_log}` : '')
        setActiveCond({
            id_central: cond.id_central,
            id: cond.id,
            link,
            nome: cond.nome,
            apelido: cond.apelido,
            cameras: cond.cameras_benuvem && cond.cameras_benuvem.length > 0 ? cond.cameras_benuvem : cond.cameras,
            obs_liberacao_temporaria: cond.edit_obs_liberacao_temporaria,
            tipo_imovel: cond.tipo_imovel,
            desc_tipo_imovel: cond.desc_tipo_imovel,
            grupos_acesso: cond.grupos_acesso,
            cameras_benuvem,
            chave: cond.chave,
            fecha_evento_visitante_automatico: cond.fecha_evento_visitante_automatico,
            liberacao_padrao_visitante: cond.liberacao_padrao_visitante,
            notifica_morador_visitante: cond.notifica_morador_visitante || false,
            nome_doc1: cond.nome_doc1,
            nome_doc2: cond.nome_doc2,
            nome_doc3: cond.nome_doc3,
            doc1_obrigatorio: cond.doc1_obrigatorio,
            doc2_obrigatorio: cond.doc2_obrigatorio,
            doc3_obrigatorio: cond.doc3_obrigatorio,
            pais: cond.pais,
            gerar_logs_aut_obs: cond.gerar_logs_aut_obs,
            cpf_obrigatorio: cond.cpf_obrigatorio
        })
        changeShowComponent('abaWeb-tratarEvento')
        NotifyObsCond(cond.id_central, cond.nome, cond.notif_obs, cond.obs)
    }

    const rmActiveCond = (forcarRemocao) => {
        if (!selecionado_p_menu_lateral.current || forcarRemocao) { // se o condominio foi selecionado pelo menu lateral, não deve ser removido do ativo
            setActiveCond(modeloActiveCond)
        }
    }

    const currentToast = useRef(null)
    const NotifyObsCond = (id_central, nome, notif_obs, obs) => {
        if (notif_obs) {
            let options = {
                toastId: 'ObsNotif',
                position: "bottom-right",
                autoClose: false,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: false,
                theme: "light",
                onClose: CloseMsgObs
            }
            if (currentToast.current) {
                options.render = <MsgObs id_central={id_central} nome={nome} obs={obs} />
                toast.update(currentToast.current, options)
            } else {
                currentToast.current = toast(<MsgObs id_central={id_central} nome={nome} obs={obs} />, options)
            }
        } else {
            CloseMsgObs()
        }
    }

    const MsgObs = ({ id_central, nome, obs }) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                <div style={{ borderBottom: '1px solid gray', paddingBlock: '3px', fontSize: '13px' }}><b>{id_central} - {nome}</b></div>
                <div style={{ marginTop: '10px', fontSize: '12px' }}>{obs}</div>
            </div>
        )
    }

    const CloseMsgObs = () => {
        if (currentToast.current) {
            toast.dismiss(currentToast.current)
            currentToast.current = null
        }
    }

    /**
     * Essa função atualiza as informações de um condominio especifico.
     * Ex: o condominio 2000 tem nome, descricao e ativo. Você pode passar um objeto {ativo: 1} para
     * atualizar somente o campo ativo desse condominio
     */
    const alterInfoCond = (id_central, objAlter) => {
        if (!id_central || !objAlter || !condominios) { return false }

        let cond = condominios.find(el => el.id_central === id_central)
        if (!cond) { return false }

        let newObj = {}
        Object.keys(objAlter).forEach(key => {
            /* eslint-disable no-prototype-builtins */
            if (cond.hasOwnProperty(key) && cond[key] != objAlter[key]) {
                newObj[key] = objAlter[key]
            }
        })
        let obj_aux = Object.assign(condominios, {})
        let index = condominios.findIndex(el => el.id_central === id_central)
        obj_aux[index] = Object.assign(obj_aux[index], newObj)
        setCondominios(obj_aux)
    }

    const value = { activeCond, addActiveCond, condominios, rmActiveCond, selecionado_p_menu_lateral, alterInfoCond }
    return (
        <CondominiosContext.Provider value={value}>
            <div>
                {children}
            </div>
        </CondominiosContext.Provider>
    )
}
